// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const BookMeeting = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 20 20"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M19.5 2.01c.276 0 .5.225.5.502V19.5c0 .276-.224.5-.5.5H.5c-.276 0-.5-.224-.5-.5V2.51c0-.277.224-.5.5-.5h3.49V1C3.99.448 4.44 0 4.99 0h1.012c.552 0 1 .448 1 1.002v1.01h5.983V1c0-.554.448-1.002 1-1.002h1.012c.552 0 1 .448 1 1.002v1.01H19.5zM1 19h18V7.003H1v11.995z" />
  </svg>
);
